import { FunctionalComponent, h } from 'preact';
import { InstagramIcon, TwitterIcon, YoutubeIcon, FacebookIcon } from '../../icons/Social';
import {
  DelTacoBottomMenuStyle,
  DelTacoLogoStyle,
  FooterMenu,
  FooterStyle,
  LogoImg, SocialUl,
} from './DelTacoFooter.style';


export const DelTacoFooter: FunctionalComponent = () => {
  return (
    <FooterStyle>
      <DelTacoLogoStyle>
        <LogoImg src={"https://deltaco.com/images/main-logo.svg"} alt={"Del Taco"} />
      </DelTacoLogoStyle>

      <FooterMenu>
        <li>
          <ul style={{ listStyleType: 'none' }}>
            <li><a href="https://deltaco.com/menu" className="nav-menu">Menu</a></li>
            <li><a href="https://deltaco.com/contactus" className="nav-contactus">Connect</a></li>
            <li><a href="https://deltaco.com/specials" className="nav-specials">Specials</a></li>
            <li><a href="https://locations.deltaco.com/search" className="nav-locations-go">Locations</a></li>
          </ul>
        </li>
        <li className="two">
          <ul style={{ listStyleType: 'none' }}>
            <li><a href="https://deltaco.wgiftcard.com/responsive/landing_responsive/landing/deltaco"
              className="foot-buy-gift-card" target="_blank">Buy Gift Card</a></li>
            <li><a href="https://deltaco.wgiftcard.com/rbc/deltaco" className="foot-check-gift-card-balance"
              target="_blank">Check Gift Card Balance</a></li>
            <li><a href="http://www.deltacowebstore.com/" className="foot-webstore" target="_blank"><span
              className="visually-hidden">Del Taco </span>Webstore</a></li>
          </ul>
        </li>
        <li>
          <ul style={{ listStyleType: 'none' }}>
            <li><a href="https://deltaco.com/history" className="foot-history">History</a></li>
            <li><a href="https://deltaco.com/news" className="foot-news">News</a></li>
            <li><a href="https://deltaco.com/careers" className="foot-careers">Careers</a></li>
            <li><a href="http://www.deltacofranchise.com/" className="foot-franchising"
              target="_blank">Franchising</a></li>
          </ul>
        </li>
        <li className="two">
          <ul style={{ listStyleType: 'none' }}>
            <li><a href="http://franchise.deltaco.com/" className="foot-franchising-intranet" target="_blank">Franchising
              Intranet</a></li>
            <li><a href="http://investor.deltaco.com/" className="foot-investors" target="_blank">Investors</a></li>
          </ul>
        </li>
      </FooterMenu>
      <SocialUl>
        <li>
          <a href="https://instagram.com/deltaco/" className="foot-instagram" target="_blank" title="Instagram">
            <InstagramIcon></InstagramIcon>
            <span className="icon icon-social-instagram">
              <span className="visually-hidden">Visit Del Taco on Instagram</span>
            </span>
          </a>
        </li>
        <li>
          <a href="https://twitter.com/deltaco" className="foot-twitter" target="_blank" title="Twitter">
            <TwitterIcon></TwitterIcon>
            <span className="icon icon-social-twitter">
              <span className="visually-hidden">Visit Del Taco on Twitter</span>
            </span>
          </a>
        </li>
        <li>
          <a href="https://www.facebook.com/deltaco" className="foot-facebook" target="_blank" title="Facebook">
            <FacebookIcon></FacebookIcon>
            <span className="icon icon-social-facebook">
              <span className="visually-hidden">Visit Del Taco on Facebook</span>
            </span>
          </a>
        </li>
        <li>
          <a href="https://www.youtube.com/user/deltaco" className="foot-youtube" target="_blank" title="Youtube">
            <YoutubeIcon></YoutubeIcon>
            <span className="icon icon-social-youtube">
              <span className="visually-hidden">Visit Del Taco on Youtube</span>
            </span>
          </a>
        </li>
      </SocialUl>

      <DelTacoBottomMenuStyle>
        <a href="https://deltaco.com/termsandconditions"><small>Terms of Use</small></a>
        <a href="https://deltaco.com/legal"><small>Privacy Policy</small></a>
        <a href="https://deltaco.com/ccpa"><small>Don't Sell My Info</small></a>
      </DelTacoBottomMenuStyle>
    </FooterStyle>
  );
}
